<script>
import { defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    title: {
      type: String,
      default: () => 'Null',
    },
  },
});
</script>

<template>
  <v-chip
    class="chip"
    color="#0C4439"
    text-color="white"
    disabled
  >
    {{ title }}
  </v-chip>
</template>

<style scoped>
 .chip {
  min-width: 153px !important;
  height: 32px !important;
  justify-content: center !important;
  font-style: normal !important;
  font-family: 'Neue-Metana' !important;
  font-weight: normal !important;
  font-size: 12px;
  line-height: 102%;
  margin: 0px !important;
}
</style>
